export default __webpack_public_path__ + "static/media/img-7.80d58837.jpg";